import { combineEpics } from "redux-observable";
import { projectsEpic } from './project-epics';
import { organizationsEpic } from './organization-epics';
import { resourceEpic } from './resource-epics';
import { glossaryEpic } from './glossary-epics';
import { readingListEpic, acceptRequestEpic, rejectRequestEpic } from './reading-list-epics';
import { usersEpic } from './users-epics'
import { dictionariesEpic } from "./dictionary-epics";

export default combineEpics(
    projectsEpic,
    organizationsEpic,
    resourceEpic,
    glossaryEpic,
    readingListEpic,
    acceptRequestEpic,
    rejectRequestEpic,
    usersEpic,
    dictionariesEpic
);



// WEBPACK FOOTER //
// ./src/epics/index.js